import { User } from 'services/user/types';

const ELITE_BELTS = {
  100: 'Red Belt',
  101: 'Orange Belt',
  102: 'Green Belt',
  103: 'Black Belt',
  104: 'Golden Belt',
  109: 'Black Belt D2',
  110: 'Black Belt D3',
  111: 'Black Belt D4',
  112: 'Black Belt D5',
  113: 'Black Belt D6',
  114: 'Black Belt D7',
  115: 'Black Belt D8',
  116: 'Black Belt D9',
  300: 'Sensei',
  302: 'Golden Belt D20',
  303: 'Golden Belt D30',
  304: 'Golden Belt D40',
  305: 'Golden Belt D50',
  306: 'Golden Belt D60',
  307: 'Golden Belt D70',
  308: 'Golden Belt D80',
  309: 'Golden Belt D90'
};

export function isUserElite(user?: User): boolean {
  if (!user) {
    return false;
  }

  if (!user.belt_id) {
    return false;
  }

  return Object.keys(ELITE_BELTS).some(beltId => Number(beltId) === user.belt_id);
}
